import { QueryClient } from '@tanstack/react-query';

import { MINUTE } from 'src/constants/time';

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            retry: false,
            refetchOnWindowFocus: false,
            staleTime: 5 * MINUTE,
            cacheTime: 8 * MINUTE,
        },
    },
});
